export default __webpack_public_path__ + "static/media/11.7.b2a1b5fd.jpg";